const sideMenu = [
  {
    id: "purchase_order",
    label: "Purchase Order",
    href: "/app/purchase/order",
    permissions: [1, 2]
  },
  {
    id: "purchase_list",
    label: "Purchase Management",
    href: "/app/purchase",
    permissions: [1, 2]
  },
  {
    id: "userlist",
    label: "User Management",
    href: "/app/users",
    permissions: [1]
  }
];

export default sideMenu;
